import { FC } from 'react';
import { Redirect, Switch } from 'react-router-dom';
import PruRoute from 'src/app/common/components/PruRoute';
import { NOT_FOUND_ERROR_PAGE_PATH } from 'src/app/common/constants';
import { AGENT_QUALIFICATION_DETAIL_REPORT_PATH, OPM_AD_BASE_PATH } from '../../constants';

import SearchQualificationAgentPage from './SearchQualificationAgent/SearchQualificationAgentPage';

export const agentQualificationDetailReportPath = `${OPM_AD_BASE_PATH}${AGENT_QUALIFICATION_DETAIL_REPORT_PATH}`;

const AgentQualificationDetailReportRoutes: FC = () => {
  return (
    <Switch>
      <Redirect
        exact
        from={agentQualificationDetailReportPath}
        to={`${agentQualificationDetailReportPath}/search-qualification-agent`}
      />
      <PruRoute
        exact
        path={`${agentQualificationDetailReportPath}/search-qualification-agent`}
        render={() => <SearchQualificationAgentPage />}
      />
      <Redirect to={NOT_FOUND_ERROR_PAGE_PATH} />
    </Switch>
  );
};

export default AgentQualificationDetailReportRoutes;
